<template>
    <div class="menuitem-main">
        <!-- temporary hide menu click function -->
        <div @click="gotoDetail()" class="menuitem-wrapper">
        <!-- <div class="menuitem-wrapper"> -->
            <div class="menuitem-img-wrapper">
                <img :src="menuImage" class="img-campaign" />
            </div>
            <div class="menuitem-info">
                <div class="menuitem-name">{{ campaign.name }}</div>
                <div class="menuitem-price">
                   {{ campaign.pricePerUnit }} บาท
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MenuApi from "@/module/Menu/service/missionbadge.js";
export default {
    name: "MenuItem",
    props: {
        index: Number,
        campaign: Object,
        config: Boolean
    },
    data() {
        return {
            menuImage: null
        };
    },
    created: function() {
        this.getImage();
    },
    methods: {
        getImage() {
            MenuApi.GetBlob(this.campaign.id).then(response => {
                this.menuImage = response.config.url;
            })
            .catch ((err) => {
                return err
            });
        },
        gotoDetail() {
            if(this.config) {
                this.$router.push({
                    name: "menudetail",
                    params: {
                        campaignImage: this.menuImage,
                        campaign: this.campaign
                    }
                });
            }
        }
    }
};
</script>
<style lang="scss" scoped>
@import "@/module/menu/style/menuItem.scss";
</style>
